/**
 * Generated from the "artisan make:alpine" command
 */

export type NotificationAlertType = 'success' | 'danger' | 'info';
export const NOTIFICATION_FAST_DURATION = 2000;
export const NOTIFICATION_MEDIUM_DURATION = 4000;
export const NOTIFICATION_LONG_DURATION = 10000;
export const NOTIFICATION_INFINITE_DURATION = -1;

const NOTIFICATION_ALERT_TYPES: Array<NotificationAlertType> = ["success", "danger", "info"];

export function isValidNotificationAlertType(value: string): value is NotificationAlertType {
    return NOTIFICATION_ALERT_TYPES.includes(value as NotificationAlertType);
}

export interface NotificationAlert {
    title: string
    message: string
    type: NotificationAlertType
    duration: number
    onClose: (() => void) | null
}

// Your alpine data and methods
export interface AlpineData {
    list: Map<number, NotificationAlert>
    idCounter: number
    addAlert(title: string, message: string, type: NotificationAlertType, duration: number, onClose?: NotificationAlert["onClose"]): void
    getAlerts(): Array<[number, NotificationAlert]>
    closeAlert(id: number): void
    onAppearing(id: number): void
    getAlertMessage(alert: NotificationAlert): string
}
